import React from 'react';
import { useTranslation } from 'react-i18next';

import './BuildingInfoSkeleton.scss';

const BuildingInfoSkeleton = () => {
  const { t } = useTranslation();

  return (
    <div
      className="building-info-skeleton"
      role="status"
      aria-live="polite"
      aria-label={t('common.loading', 'Loading')}
    >
      <div className="building-info-skeleton__lines" aria-hidden="true">
        {Array.from({ length: 3 }, (_, index) => (
          <span className="building-info-skeleton__line" key={index} />
        ))}
      </div>
    </div>
  );
};

export default BuildingInfoSkeleton;
